/* OPUS — tiny enhancement layer. Everything works without it.
   - Opus "add" buttons use the theme's own cart notification (same as product pages)
   - Tapping the bag icon opens the cart drawer, refreshed so it always shows the latest bag */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toast;

  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'o-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span>' + msg + '</span><a href="' + root + 'cart">view bag</a>';
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }

  function refreshBubble() {
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !d['cart-icon-bubble']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = d['cart-icon-bubble'];
        var fresh = tmp.querySelector('.shopify-section');
        el.innerHTML = (fresh || tmp).innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- add to bag from Opus sections ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-o-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var notif = document.querySelector('cart-notification');
    var body = new FormData(form);
    if (notif && typeof notif.renderContents === 'function') {
      body.append('sections', 'cart-notification-product,cart-notification-button,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
    }

    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || 'could not add');
        if (notif && res.j.sections) {
          notif.renderContents(res.j);
        } else {
          showToast('added to your bag');
          refreshBubble();
        }
      })
      .catch(function (err) { showToast(String(err.message || 'try again').toLowerCase()); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* ---------- bag icon opens a fresh cart drawer ---------- */
  function openFreshDrawer(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') { window.location.href = root + 'cart'; return; }
    fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var tmp = document.createElement('div');
        tmp.innerHTML = s['cart-drawer'] || '';
        var freshDrawer = tmp.querySelector('cart-drawer');
        if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        var freshInner = tmp.querySelector('#CartDrawer');
        var inner = drawer.querySelector('#CartDrawer');
        if (freshInner && inner) inner.innerHTML = freshInner.innerHTML;
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        if (s['cart-icon-bubble']) {
          var b = document.createElement('div');
          b.innerHTML = s['cart-icon-bubble'];
          var bubble = document.getElementById('cart-icon-bubble');
          var sec = b.querySelector('.shopify-section');
          if (bubble) bubble.innerHTML = (sec || b).innerHTML;
        }
        drawer.open(trigger);
      })
      .catch(function () { drawer.open(trigger); });
  }

  function onBagIntent(e) {
    var link = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!link || !document.querySelector('cart-drawer')) return;
    if (e.type === 'keydown' && e.code !== 'Space' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    openFreshDrawer(link);
  }
  document.addEventListener('click', onBagIntent, true);
  document.addEventListener('keydown', onBagIntent, true);

  /* ---------- size picker: keep the button label in sync ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('[data-o-variant]')) return;
    var form = input.closest('form');
    var out = form && form.querySelector('[data-o-price]');
    if (out) out.textContent = input.dataset.price;
    var btn = form && form.querySelector('[type="submit"]');
    if (btn) btn.disabled = input.dataset.available !== 'true';
  });

  /* ---------- sticky mobile bar ---------- */
  var bar = document.querySelector('[data-o-sticky]');
  var hero = document.querySelector('[data-o-hero]');
  if (bar && hero && 'IntersectionObserver' in window) {
    var heroGone = false, footerIn = false;
    var foot = document.querySelector('[data-o-close], footer, .footer');
    var sync = function () { var on = heroGone && !footerIn; bar.classList.toggle('is-on', on); bar.inert = !on; };
    new IntersectionObserver(function (en) { heroGone = !en[0].isIntersecting; sync(); }).observe(hero);
    if (foot) new IntersectionObserver(function (en) { footerIn = en[0].isIntersecting; sync(); }).observe(foot);
  }
})();
